<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 12 12"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    class="icon"
  >
    <g
      id="Design-System"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="DesignSystem"
        transform="translate(-740.000000, -13082.000000)"
        fill-rule="nonzero"
      >
        <g
          id="Group-19"
          transform="translate(740.003379, 13081.999987)"
        >
          <path
            id="Path"
            d="M1.03904175,2.62216773 C-0.820730758,5.35481431 -0.120946152,9.13316266 2.63449677,10.9285201 C6.61040645,13.5190942 9.98421596,10.7799778 10.964793,9.33909221 C12.8246072,6.60644563 12.110266,2.88756447 9.36933793,1.03273985 C6.62840984,-0.822084769 2.89881426,-0.110478848 1.03904175,2.62216773 Z"
            :fill="bgcolor"
          />
          <path
            id="Path"
            d="M6.0429713,9.97920348 C5.49067224,9.97920348 5.0429713,9.55501495 5.0429713,9.03172159 L5.0429713,5.92668537 C5.0429713,5.40339201 5.49067224,4.97920348 6.0429713,4.97920348 C6.59527036,4.97920348 7.0429713,5.40339201 7.0429713,5.92668537 L7.0429713,9.03172159 C7.0429713,9.55496527 6.59527036,9.97920348 6.0429713,9.97920348 L6.0429713,9.97920348 Z"
            :fill="fgcolor"
          />
          <path
            id="Path"
            d="M5.0429713,3.03763205 C5.0429713,2.48533299 5.49067224,2.03763205 6.0429713,2.03763205 C6.59527036,2.03763205 7.0429713,2.48533299 7.0429713,3.03763205 C7.0429713,3.58987868 6.59527036,4.03763205 6.0429713,4.03763205 C5.49067224,4.03763205 5.0429713,3.58993112 5.0429713,3.03763205 Z"
            :fill="fgcolor"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
export default defineNuxtComponent({
  props: {
    size: {
      type: Number,
      default: 12
    },
    variant: {
      type: String,
      default: 'yellow', // yellow, semi-light, light, dark
    },
  },
  setup(props) {
    const color = (() => {
      if (props.variant === 'dark') {
        return { bg: '#303030', fg: '#FFFFFF'}
      }
      if (props.variant === 'semi-light') {
        return { bg: '#cacaca', fg: '#FFFFFF'}
      }
      if (props.variant === 'light') {
        return { bg: '#fafafa', fg: '#565656'}
      }

      // Default: yellow
      return { bg: '#FFD54D', fg: '#FFFFFF'}
    })()

    const width = props.size
    const height = props.size

    return {
      width,
      height,
      bgcolor: color.bg,
      fgcolor: color.fg,
    }
  }
})
</script>
